import React, {FC, useEffect, useMemo, useState} from 'react';
import {
    RecognizableAndTranslatableLanguage,
    SessionStates,
    TranslatableAndSpeakableLanguage
} from '../contexts/Configuration';
import {buildLanguageMatrixV2} from '../contexts/SessionContext';
import {Autocomplete, TextField} from '@mui/material';
import {useAppDispatch, useAppSelector} from '../hooks/storeHooks';
import {updateSessionState} from '../reducers/sessionReducer';

const LanguageSelector: FC<LanguageSelectorProps> = ({
                                                         id,
                                                         isInputSelector,
                                                         onLanguageSelected
                                                     }) => {

    const started = useAppSelector((state) => state.session.sessionStarted);
    const sessionState = useAppSelector((state) => state.session.sessionState);

    const preSelectedInputLanguage = useAppSelector((state) => state.session.preSelectedInputLanguage);
    const preSelectedOutputLanguages = useAppSelector((state) => state.session.preSelectedOutputLanguages);
    const autoDetectLang = useAppSelector((state) => state.session.autoDetectLang);
    const input = useAppSelector((state) => state.session.input);
    const outputs = useAppSelector((state) => state.session.outputs);
    // const alreadySelected = useAppSelector((state) => state.session.alreadySelected);

    const dispatch = useAppDispatch();

    const [inputOptions, setInputOptions] = useState<RecognizableAndTranslatableLanguage[]>([])
    const [outputOptions, setOutputOptions] = useState<TranslatableAndSpeakableLanguage[]>([])
    useEffect(() => {
        buildLanguageMatrixV2()
            .then((results: { a: RecognizableAndTranslatableLanguage[], b: TranslatableAndSpeakableLanguage[] }) => {
                // console.log('buildLanguageMatrix_V2', results)
                setInputOptions(results.a);
                setOutputOptions(results.b);

                dispatch(updateSessionState({state: SessionStates.OFF}));

                // if (isInputSelector)
                //     console.log("preSelectedInputLanguage: ", preSelectedInputLanguage, "input", input)

                //if (!isInputSelector)
                    //console.log("preSelectedOutputLanguages: ", preSelectedOutputLanguages, "outputs", outputs)

                if (isInputSelector && !!preSelectedInputLanguage) {
                    // console.debug("[3] LOAD LANGUAGE SELECTOR:", preSelectedInputLanguage);
                    //console.debug('LANGS', results.a)
                    const preSelected = results.a
                        .find(l => l.recognitionKey === preSelectedInputLanguage);

                    if (!!preSelected /*&& !!input?.language*/) {
                        onLanguageSelected(preSelected);
                    }
                }

                // console.log('Tenemos output?', !isInputSelector && !!preSelectedOutputLanguages, preSelectedOutputLanguages)
                if (!isInputSelector && !!preSelectedOutputLanguages && !!preSelectedOutputLanguages[id] && preSelectedOutputLanguages[id].includes(':')) {
                    const preSelectedKeys = preSelectedOutputLanguages[id].split(':');
                    if (preSelectedKeys.length === 2) {
                        const preSelected = results.b
                            .find(l => l.translationKey === preSelectedKeys[0] &&
                                l.speakKey === preSelectedKeys[1]
                            );
                        if (!!preSelected /*&& !!outputs.find(o => !o.isExtra)?.language*/) {
                            onLanguageSelected(preSelected);
                        }
                    }

                }
            });
    }, []);


    const label = `${isInputSelector ? 'Input' : 'Output'} language`;
    const automaticDetectionLabel = 'Automatic detection';

    const outputLangSelected = useMemo(() => {
        return outputs?.find(o => o.id === id)?.language || null;
    }, [outputs, id]);

    if (isInputSelector) {
        // console.log("RENDERING LANGUAGE SELECTOR:", input)
        return (
            <Autocomplete
                id="selectableLanguages"
                filterSelectedOptions
                loading={outputOptions.length === 0 || sessionState === SessionStates.LOADING}
                loadingText="Loading Languages"
                disabled={started || autoDetectLang}
                className="lang-selector-container-input"
                options={inputOptions}
                getOptionLabel={op => autoDetectLang ? automaticDetectionLabel : op.name}
                isOptionEqualToValue={(option, value) => {
                    const equals = value !== undefined && value !== null &&
                        /*option.translationKey === value.translationKey &&*/ option.recognitionKey === value.recognitionKey;
                    return equals;
                }}
                value={input?.language || null}
                onChange={(_e, newValue) => {
                    onLanguageSelected(newValue)
                }}
                renderInput={(params) =>
                    <TextField{...params} size="small" placeholder={autoDetectLang ? automaticDetectionLabel : label}/>
                }
            />

        );
    }

    return (
        <Autocomplete
            id="selectableLanguageOptions"
            filterSelectedOptions
            loading={outputOptions.length === 0}
            loadingText="Loading Languages"
            disabled={started}
            className="lang-selector-container"
            options={outputOptions}
            getOptionLabel={op => op.name}
            isOptionEqualToValue={(option, value) => {
                return value !== undefined && value !== null &&
                    option.translationKey === value.translationKey && option.speakKey === value.speakKey;
            }}
            value={outputLangSelected}
            onChange={(_e, newValue) => {
                onLanguageSelected(newValue);
            }}
            renderInput={(params) =>
                <TextField{...params} size="small" placeholder={label}/>
            }
            // inputValue={outputLang?.name || ''}
            // onInputChange={(_e, value) => {
            //     const matchedOption = outputOptions.find(
            //         (option) => option.name.toLowerCase() === value.toLowerCase()
            //     );
            //     if (!matchedOption) {
            //         console.log("acacaca - output", matchedOption);
            //     } else {
            //         setOutputLang(matchedOption);
            //     }
            // }}
        />
    )

}

type LanguageSelectorProps = {
    id: string,
    isInputSelector: boolean,
    // options: RecognizableAndTranslatableLanguage[] | TranslatableAndSpeakableLanguage[];
    onLanguageSelected: (selected: RecognizableAndTranslatableLanguage | TranslatableAndSpeakableLanguage | null) => void;
}

export default LanguageSelector
